import React from 'react';

import { MDText } from 'i18n-react';

import { HighDemandFireIcon } from './HighDemandFireIcon';
import LocalTexts from './HighDemandVehicle.texts.json';

import styles from './HighDemandVehicle.module.scss';

const LocalT = new MDText(LocalTexts);

export const HighDemandValuationHeading = () => (
  <span className={styles.valuationHeading} data-testid='highDemandValuationHeading'>
    {LocalT.translate('valuationHeading', {
      emphasis: (
        <React.Fragment key='emphasis'>
          <HighDemandFireIcon />
          <em className={styles.headingEmphasis}>
            {LocalT.translate('valuationHeadingEmphasis')}
          </em>
          <HighDemandFireIcon />
        </React.Fragment>
      ),
    })}
  </span>
);
